import { useGridApiRef } from '@mui/x-data-grid-premium';
import { MutableRefObject, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { CustomGridApi } from '../components/common/XTable/types';
import { PageNameType } from '../redux/clientConfiguration/clientConfigurationSlice';
import reduxSlicesList from '../redux/reduxSlicesList';
import { RootState } from '../redux/store';
import { setConfigStorageItem } from './useConfigStorage';

const useTablePage = (pageName: PageNameType) => {
 const apiRef = useGridApiRef() as MutableRefObject<CustomGridApi>;

 const dispatch = useDispatch();

 const selector = useSelector(
  (state: RootState) => state[pageName as PageNameType],
 );

 const { items, rowCount, loading, success } = selector;

 useEffect(() => {
  dispatch(
   reduxSlicesList[
    pageName as keyof typeof reduxSlicesList
   ]?.getTableStructureStart({
    table: pageName,
   }),
  );

  // this loads current preset
 }, [dispatch, pageName]);

 useEffect(() => {
  if (
   selector.success.deleteItem ||
   selector.success.approveResult ||
   selector.success.updateItem ||
   selector.success.createItem
  ) {
   console.log('useTablePage ue', selector.success);
   apiRef.current.fetchData();
   // reset selected rows
   apiRef.current.setRowSelectionModel([]);
  }
 }, [selector.success, apiRef]);

 useEffect(() => {
  //   console.log(selector.success);
  // why is this needed?
  if (selector.success.getTableStructure) {
   setConfigStorageItem({
    page: pageName, // 'results'
    key: 'structure',
    value: selector.structure,
   });
  }
 }, [selector.success, selector.structure]);

 return { apiRef, items, rowCount, loading, dispatch, success };
};

export default useTablePage;

